import JsApi from './JsApi'

export default JsApi
